import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ErrormessageModule } from '../../components/validation/errormessage/errormessage.module';

import { PCPAccountCategoryAutoCompleteComponent } from "./pcp-accountcategory-autocomplete.component";

@NgModule({
    imports: [
        CommonModule,
        ErrormessageModule,
        FormsModule,
        AutoCompleteModule,
        PCPAccountCategoryAutoCompleteComponent,
    ],
    exports: [PCPAccountCategoryAutoCompleteComponent]
})
export class PCPAccountCategoryAutoCompleteModule { }
